import React from 'react';
import styles from './stepsIndicator.scss';
import cx from 'classnames';

var StepsIndicator = function StepsIndicator(props) {
  var steps = props.steps,
      currentIndex = props.currentIndex,
      onStepClick = props.onStepClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "stepContainer",
    style: {
      display: 'flex'
    }
  }, steps.map(function (step, i) {
    var _cx;

    var isClickable = !!step.clickable;

    var _onClick = isClickable ? function () {
      return onStepClick(step, i);
    } : function () {};

    return /*#__PURE__*/React.createElement("div", {
      onClick: _onClick,
      key: i,
      className: cx(styles.step, (_cx = {}, _cx[styles.selected] = i === currentIndex, _cx[styles.clickable] = isClickable, _cx))
    });
  }));
};

export default StepsIndicator;